// Раскладка экрана тренировки на телефоне: какие упражнения раскрыты и прокрутка открытого
// подхода под липкие заголовки — чтобы клавиатура, выезжая, не двигала поля под пальцем.

import { useCallback, useEffect, useState } from 'react'

const OPEN_KEY = 'health.workout.open'
/** Зазор между липкими заголовками и подходом, px. */
const GAP = 8
/** Сколько ждать, пока выедет клавиатура, мс. */
const KEYBOARD_MS = 350

type Stored = { id: string; keys: string[] }

function readOpen(workoutId: string): string[] {
  try {
    const value = JSON.parse(sessionStorage.getItem(OPEN_KEY) ?? 'null') as Stored | null
    return value?.id === workoutId && Array.isArray(value.keys) ? value.keys : []
  } catch {
    return []
  }
}

/** Раскрытые упражнения; переживают уход на другой экран и перезагрузку вкладки. */
export function useOpenExercises(workoutId: string) {
  const [open, setOpen] = useState<ReadonlySet<string>>(() => new Set(readOpen(workoutId)))
  useEffect(() => {
    try {
      sessionStorage.setItem(OPEN_KEY, JSON.stringify({ id: workoutId, keys: [...open] } satisfies Stored))
    } catch {
      // приватный режим — раскрытие просто не запомнится
    }
  }, [workoutId, open])
  const toggle = useCallback((key: string) => {
    setOpen((prev) => {
      const next = new Set(prev)
      if (next.has(key)) next.delete(key)
      else next.add(key)
      return next
    })
  }, [])
  const expand = useCallback((key: string) => setOpen((prev) => new Set(prev).add(key)), [])
  return { open, toggle, expand }
}

/** Поднять элемент вплотную под шапку тренировки и липкий заголовок его упражнения. */
export function scrollUnderHeads(el: HTMLElement): void {
  const head = document.querySelector('[data-workout-head]')?.getBoundingClientRect().bottom ?? 0
  const exerciseHead = el.closest('section')?.querySelector('[data-exercise-head]')?.getBoundingClientRect().height ?? 0
  const top = el.getBoundingClientRect().top - Math.max(0, head) - exerciseHead - GAP
  if (Math.abs(top) < 2) return
  window.scrollBy({ top, behavior: 'smooth' })
}

/** То же после того, как выехала клавиатура (поле получило фокус). */
export function scrollUnderHeadsAfterKeyboard(el: HTMLElement): void {
  window.setTimeout(() => scrollUnderHeads(el), KEYBOARD_MS)
}
